import { render, staticRenderFns } from "./DeleteWishList.vue?vue&type=template&id=316b6ca2&scoped=true"
import script from "./DeleteWishList.vue?vue&type=script&lang=js"
export * from "./DeleteWishList.vue?vue&type=script&lang=js"
import style0 from "./DeleteWishList.vue?vue&type=style&index=0&id=316b6ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b6ca2",
  null
  
)

export default component.exports